import { AppContext } from "../core/context";
import { ConnectorInfo } from "../types/type_def";

export function getHorizontalPlaneVector(ctx: AppContext, y, pos, rot) {
    if (!rot.y) {
        return null; // no solution, as it will never hit the zero plane
    }
    return new BABYLON.Vector3(
        pos.x - (pos.y - y) * rot.x / rot.y,
        0,
        pos.z - (pos.y - y) * rot.z / rot.y
    );
}

export function getZeroPlaneVector(ctx: AppContext, pos, rot) {
    return getHorizontalPlaneVector(ctx, 0, pos, rot);
}

export function getTargetPosition(ctx: AppContext, screenX: number, screenY: number) {

    var target = BABYLON.Vector3.Unproject(
        new BABYLON.Vector3(screenX, screenY, 0),
        ctx.canvas.width,
        ctx.canvas.height,
        BABYLON.Matrix.Identity(),
        ctx.mainCamera.getViewMatrix(),
        ctx.mainCamera.getProjectionMatrix()
    );

    target.x = ctx.mainCamera.position.x - target.x;
    target.y = ctx.mainCamera.position.y - target.y;
    target.z = ctx.mainCamera.position.z - target.z;

    return target;

}

export function getPositionConnectorInfo(ctx: AppContext, position: BABYLON.Vector2, mesh: BABYLON.TransformNode) {

    let connectorInfos = [] as Array<ConnectorInfo>;

    var ray = ctx.scene.createPickingRay(position.x, position.y, BABYLON.Matrix.Identity(), ctx.mainCamera);
    var pickingInfo: BABYLON.PickingInfo[] = ctx.scene.multiPickWithRay(ray, function (pickmesh) { return BABYLON.Tags.MatchesQuery(pickmesh, "connector") && pickmesh.parent !== mesh });

    pickingInfo.forEach(function (pi) {

        if (pi.pickedMesh) {

            var connectorMesh = pi.pickedMesh;

            //console.log(connectorMesh.id)
            if (connectorMesh.isEnabled()) {
                let connectorInfo = {} as ConnectorInfo;
                connectorInfo.entityNode = connectorMesh.parent as BABYLON.AbstractMesh;
                connectorInfo.connectorNode = connectorMesh;                   
                connectorInfo.isEnabled = connectorMesh.isEnabled();
                connectorInfos.push(connectorInfo);
            }

        }
    });

    return connectorInfos;
}
